<template>
  <vbt-dialog
    v-model="dialog"
    :title="title"
    :submit-btn-name="submitBtnName"
    width="700px"
    @submit="submitForm"
    @close="$_resetFormValidation"
  >
    <v-form :ref="formRef">
      <v-text-field
        v-model.trim="form.name"
        :rules="validator.getRulesByField('name')"
        label="Name"
        @keypress.enter="submitForm"
      />
      <v-text-field
        v-model.trim="form.email"
        :rules="validator.getRulesByField('email')"
        label="Email"
        @keypress.enter="submitForm"
      />
      <ums-password-field
        v-if="creator"
        v-model="form.password"
        @keypress.enter="submitForm"
      />
      <v-text-field
        v-if="creator"
        v-model.trim="form.barcode"
        label="Barcode"
        @keypress.enter="submitForm"
      />
      <v-select
        v-if="creator"
        v-model="form.tenant"
        :rules="validator.getRulesByField('tenant')"
        :items="tenants"
        label="Tenant"
      />
    </v-form>
  </vbt-dialog>
</template>

<script>
import { mapState } from 'vuex';

import { useDialog, useEditor, useFormWithRef } from '@mixins/factories';

import { Validator, wrapToLoadingFn } from '@helpers';

import { namespace as TenantsNamespace } from '@modules/tenants/store.types';

import UsersApiService from '../_services/users.api.service';

import { generateUserModel } from '../_models/user.model';

const validator = Validator.createValidator({
  name: ['required'],
  email: ['required'],
  tenant: ['required'],
});

export default {
  name: 'UmsUserEditor',
  mixins: [
    useFormWithRef(),
    Validator.useValidator(validator),
    useDialog({ openHandlerName: 'setForm' }),
    useEditor({ formGenerator: generateUserModel }),
  ],
  computed: {
    ...mapState(TenantsNamespace, {
      tenants: ({ allTenants }) => allTenants.map(({ name }) => name),
    }),
    title() {
      return this.creator ? 'Create user' : `Edit ${this.item.name}`;
    },
    action() {
      return this.creator ? UsersApiService.createUser : UsersApiService.updateUser;
    },
    submitPromptText() {
      return this.creator ? 'Create user?' : `Update user ${this.item.name}`;
    },
  },
  methods: {
    wrapToLoadingFn,
    submitForm() {
      if (!this.$_validateForm()) {
        return;
      }

      this.$VBlackerTheme.alert.warning({
        text: this.submitPromptText,
      }, () => this.wrapToLoadingFn({
        req: this.action.bind({}, { id: this.form.id, data: this.form }),
        fullscreenLoadingSpinner: true,
        onSuccess: () => {
          this.$VBlackerTheme.notification.success(`Successfully ${
            this.creator ? 'created' : 'updated'
          }`);
          this.$emit('success');
          this.$_closeDialog();
        },
      }));
    },
  },
};
</script>
